// extracted by mini-css-extract-plugin
export default {"count":"Navbar_count__aMQg8","social":"Navbar_social__5HM37"};